import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { BookingProvider, useBooking } from "./context/BookingContext";
import { ThemeProvider } from "./context/ThemeProvider";
import { ContentProvider } from "./context/ContentProvider";
import Layout from "./components/Layout";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import SearchStep from "./pages/SearchStep";
import WidgetPage from "./pages/WidgetPage";
import ErrorPage404 from "./pages/ErrorPage404";

// Inner component that uses context
function AppContent() {
  const {
    hotelSlug,
    setHotelSlug,
    isEmbedded,
    setIsEmbedded,
    fetchAndSetHotel,
    selectedHotel,
  } = useBooking();

  useEffect(() => {
    // Read URL parameters and update context
    const urlParams = new URLSearchParams(window.location.search);
    const hotel =
      urlParams.get("hotelId") || urlParams.get("hotel") || "Hôtel Adriatica";
    const embedded = urlParams.get("embedded") === "true";

    console.log("Detected parameters:", { hotel, embedded });

    // Always set the hotel slug and fetch hotel data on mount
    setHotelSlug(hotel);
    fetchAndSetHotel(hotel);

    setIsEmbedded(embedded);

    // Add CSS class if embedded
    if (embedded) {
      document.body.classList.add("embedded-mode");
    }

    return () => {
      document.body.classList.remove("embedded-mode");
    };
  }, [fetchAndSetHotel]); // Empty dependency array - only run once on mount

  return (
    <>
      {isEmbedded && (
        <div className="bg-[#FFDD00] py-2 px-4 text-center text-sm font-medium">
          Réservation - {selectedHotel?.name || hotelSlug}
        </div>
      )}
      <Routes>
        {/* Hotel-specific routes - only hotel-adriatica is valid */}
        <Route path="/hotel-adriatica" element={<Layout />}>
          <Route index element={<SearchStep />} />
        </Route>

        {/* About page */}
        <Route path="/about" element={<Layout />}>
          <Route index element={<About />} />
        </Route>

        {/* Contact page */}
        <Route path="/contact-us" element={<Layout />}>
          <Route index element={<ContactUs />} />
        </Route>

        {/* Widget route removed - no longer needed */}
        <Route path="/widget" element={<WidgetPage />} />
        <Route path="/404" element={<ErrorPage404 />} />

        {/* Root page - blank page */}
        {/* <Route path="/" element={<div />} /> */}

        {/* Catch-all route for 404 */}
        <Route path="*" element={<ErrorPage404 />} />
      </Routes>
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center hotel-loading">
        <div className="text-xl">Chargement...</div>
      </div>
    );
  }

  return (
    <BookingProvider>
      <ThemeProvider>
        <ContentProvider>
          <AppContent />
        </ContentProvider>
      </ThemeProvider>
    </BookingProvider>
  );
}

export default App;
